import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown';

interface MarkdownOptions {
  content: string;
  isEditable: boolean;
}

export default function MarkdownPlugin({ content, isEditable }: MarkdownOptions) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(false);

    editor.update(() => {
      $convertFromMarkdownString(content, TRANSFORMERS);
    });

    requestAnimationFrame(() => {
      editor.setEditable(isEditable);
    });

  }, [content, editor, isEditable]);

  return null;
}
